import Cookies from 'js-cookie'
import {
  ADMIN_MENU,
  ADMIN_MENU_WITHOUT_CALL_CENTER,
  Constant,
  LOCAL_STORAGE_KEY,
  PERMISSION_KEY,
  SUPER_ADMIN_MENU
} from '../common/constant'
import * as types from './mutation-types'
import router from '../router'
import session from '../api/session'
import Utils from '../common/utils'

const TOKEN_NAME = Constant.TOKEN_NAME
const REFRESH_TOKEN = Constant.REFRESH_TOKEN
const MENU_PERMISSIONS = Constant.MENU_PERMISSIONS
const EDIT_PERMISSIONS = Constant.EDIT_PERMISSIONS
const READ_PERMISSIONS = Constant.READ_PERMISSIONS
const APP_USR = Constant.APP_USR

export const login = ({commit}, {token, refresh}) => {
  Cookies.set(TOKEN_NAME, token, {expires: 365})
  Cookies.set(REFRESH_TOKEN, refresh, {expires: 365})
  commit(types.LOGIN, {token, refresh})
  session.defaults.headers['Authorization'] = `Bearer ${token}`
}

export const updateUser = ({commit}, {userInfo}) => {
  Cookies.set(APP_USR, userInfo, {expires: 365})
  commit(types.UPDATE_USER, {userInfo})
}

export const updateMenu = ({commit}, {userInfo}) => {
  let menu_permissions = []
  const loadMenuFromServer = true
  if (userInfo.menu && userInfo.menu.length > 0 && loadMenuFromServer) {
    menu_permissions = userInfo.menu
  } else {
    if (Utils.isSuperUser(userInfo)) {
      menu_permissions = SUPER_ADMIN_MENU
    }
    if (Utils.isAdminUser(userInfo)) {
      menu_permissions = userInfo.call_center.sip_server ? ADMIN_MENU : ADMIN_MENU_WITHOUT_CALL_CENTER
    } else {
      userInfo.roles.forEach(item => {
        const menu = [...item.edit_permissions, ...item.read_permissions]
        menu_permissions = menu_permissions.concat(menu)
      })
      menu_permissions = menu_permissions.filter(function (item, pos) {
        return menu_permissions.indexOf(item) === pos
      })
    }
  }

  if (menu_permissions.find(item => item === PERMISSION_KEY.PHONE_NUMBER_MANAGER) && menu_permissions.find(item => item === PERMISSION_KEY.PHONE_NUMBER_TECHNICAL)) {
    menu_permissions = menu_permissions.filter(menu => menu !== PERMISSION_KEY.PHONE_NUMBER_MANAGER)
    menu_permissions = menu_permissions.filter(menu => menu !== PERMISSION_KEY.PHONE_NUMBER_TECHNICAL)
    menu_permissions.push(PERMISSION_KEY.PHONE_NUMBER_ADMIN)
  }

  Cookies.set(MENU_PERMISSIONS, menu_permissions, {expires: 365})
  commit(types.UPDATE_MENU, {menu_permissions})
}

export const updatePermission = ({commit}, {userInfo}) => {
  let edit_permissions = []
  let read_permissions = []
  userInfo.roles.forEach(item => {
    edit_permissions = edit_permissions.concat(item.edit_permissions)
    read_permissions = read_permissions.concat(item.read_permissions)
  })
  edit_permissions = edit_permissions.filter(function (item, pos) {
    return edit_permissions.indexOf(item) === pos
  })
  read_permissions = read_permissions.filter(function (item, pos) {
    return read_permissions.indexOf(item) === pos
  })
  if (Utils.isAdminUser(userInfo)) {
    edit_permissions.push(PERMISSION_KEY.USER_MANAGEMENT, PERMISSION_KEY.PRODUCT_AND_WAREHOUSE)
  }
  Cookies.set(EDIT_PERMISSIONS, edit_permissions, {expires: 365})
  Cookies.set(READ_PERMISSIONS, read_permissions, {expires: 365})
  commit(types.UPDATE_PERMISSION, {edit_permissions, read_permissions})
}

export const logout = ({commit}) => {
  Cookies.remove(TOKEN_NAME)
  Cookies.remove(REFRESH_TOKEN)
  Cookies.remove(APP_USR)
  Cookies.remove(MENU_PERMISSIONS)
  Cookies.remove(EDIT_PERMISSIONS)
  Cookies.remove(READ_PERMISSIONS)
  commit(types.UPDATE_PERMISSION, {edit_permissions: [], read_permissions: []})
  commit(types.UPDATE_MENU, {menu_permissions: []})
  commit(types.UPDATE_USER, {userInfo: null})
  commit(types.LOGOUT)
  localStorage.removeItem(LOCAL_STORAGE_KEY.ORDER_LIST_FROM_DATE)
  localStorage.removeItem(LOCAL_STORAGE_KEY.ORDER_LIST_TO_DATE)
  // localStorage.removeItem(LOCAL_STORAGE_KEY.ORDER_LIST_SEARCH_ITEMS)
  // localStorage.removeItem(LOCAL_STORAGE_KEY.REPORT_NEW_ORDER_SEARCH_ITEMS)
  // localStorage.removeItem(LOCAL_STORAGE_KEY.REPORT_BAD_DEBT_SEARCH_ITEMS)
  // localStorage.removeItem(LOCAL_STORAGE_KEY.REPORT_ANNUAL_REVENUE_SEARCH_ITEMS)
  router.push({name: 'Login'})
}

export const changeMenu = ({commit}, {routerName}) => {
  commit(types.CHANGE_MENU, routerName)
}

export const changePhoneNumber = ({commit}, {phoneNumber}) => {
  commit(types.CHANGE_PHONE_NUMBER, phoneNumber)
}

export const openSoftphone = ({commit}, {status}) => {
  commit(types.OPEN_SOFT_PHONE, status)
}

export const updateNoti = ({commit}, {status}) => {
  commit(types.UPDATE_NOTI, status)
}

export const updateInitOrderDetailId = ({commit}, {selectedOrderDetail}) => {
  commit(types.UPDATE_ANNUAL_ORDER_DETAIL, selectedOrderDetail)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js